import React, { useState, useEffect, useContext } from 'react';
//import { useSelector, shallowEqual } from "react-redux"
import ExamBasic from './ExamBasic'
//import EndList from './EndList'
import { BasicContext } from '../context/BasicContext'
import { ExamContext } from '../context/ExamContext'
import Timer from './TimerType2'
//import WebService from '../WebService/WebService';

import WebServiceContext from '../WebService/ServiceContext'
import { CloudComplete, Search } from '../course/SVG';
import ExamCheck from './ExamCheck';
import { HibModal } from '../course/HibModal';

type ExamProps = {
    //endTest: (end: string) => void
    answerResult: boolean
    answerNum: number
}


const ExamBody = (props: ExamProps) => {

    const [timer, setTimer] = useState<number>(0);
    const [timesUp, setTimesUp] = useState<boolean>(false);
    const [timerSw, setTimerSw] = useState<boolean>(true)
    const [isComplete, setIsComplete] = useState<boolean>(false)
    const [isUploading, setIsUploading] = useState<boolean>(false)

    const [num, setNum] = useState<number>(props.answerNum)
    const [total, setTotal] = useState<number>(0)
    const [open, setOpen] = useState<boolean>(false)

    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)
    const ec = useContext(ExamContext)

    useEffect(() => {
        if (ec.examInfo.TestMinute) {
            setTimer(ec.examInfo.TestMinute)
            const _w: any = window
            if (_w && _w.hib168 && _w.hib168.TimeoutTimer != undefined) {
                _w.hib168.TimeoutTimer(null, ec.examInfo.TestMinute)
            }
        }
    }, [ec.examInfo])

    //const [ansResult, setAnsResult] = useState<boolean[]>([])


    useEffect(() => {
        if(ec.examInfo.AnsKind == "1" && num == ec.examData.length) {
            setIsComplete(true)
            handInPaper()
        }
    }, [num])

    const doAnswer = (ans: boolean) => {

        if (ec.examInfo.AnsKind == "1") {
            //過關型
            if (ans) {
                setNum(num + 1)
            }
        } else if (ec.examInfo.AnsKind == "2") {
            //記錄型            
            setNum(num + 1)
        } else {
            alert("沒有類型")
        }
    }

    const handInPaper = () => {
        if (num >= ec.examData.length && ec.examData.length != 0) {
            //setTimeout(()=>{
            setIsComplete(true)
            ws.ExamService.saveExamResult(
                bc.ActID,
                ec.examInfo.ExamID.toString(),
                (ec.examInfo.AnsKind == "1" ? "100" : countScore())

            ).then((res: any) => {
                if ((res.Result as string) == "OK") {
                    setIsUploading(true)
                    return true
                }
            }).then(() => {
                ws.ExamService.tempDataAction({
                    Action: "DEL",
                    ActID: bc.ActID,
                    ExamID: ec.examInfo.ExamID
                } as TempDataObject)

                ec.record.map((item: ExamRightAnswer, index: number) => {
                    ws.WebService.asyncAnswerQuestionnaire(
                        ec.examInfo.ExamID,
                        bc.ActID,
                        (ec.examData[index] as ExamUnit).QSNo,
                        item.userAns.ItemID,
                        undefined,
                    ).then(res => {
                        console.log("asyncAnswerQuestionnaire result", res)
                    })


                })
            })
        }
    }

    const reTest = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (ec.examInfo.TestMinute) {
            setTimer(ec.examInfo.TestMinute * 60)
        }
        setNum(0)
        setTimesUp(false)
        setTimerSw(true)
        setIsComplete(false)
        setIsUploading(false)
        ec.setRecord([])
        ec.setIsTesting(false)
    }

    const countScore = (): string => {
        let count: number = 0
        ec.record.map((item: ExamRightAnswer) => {
            if (item.rightAns == item.userAns) {
                count++
            }
        })
        return (Math.ceil(((count / ec.examData.length) * 100)).toString())
        //return (Math.ceil(((count / ec.record.length) * 100)).toString())
    }


    const ExamResult = () =>
        <div className='testResult'>
            <span className='text'>
                您本次測驗結果
            </span>
            <div>
                <span></span>

            </div>
            <span className='score'>
                {
                    ec.examInfo.AnsKind == "1" ?
                        "100分" :
                        countScore() + "分"
                }
            </span>
        </div>


    if (ec.examData) {
        return (

            <>
                {
                    timer != 0 && !timesUp && !isComplete &&
                    <Timer
                        time={timer}
                        isPlay={timerSw}
                        isEnd={(end: string) => {
                            setTimesUp(true);
                            setTimerSw(false)//Timer計時停止
                            //console.log(end)
                        }}
                    />
                }

                {
                    timesUp ?
                        <>
                            <p>時間到!停止測驗，請重新作答</p>
                            {
                                ec.examInfo.ExamType == "1" &&
                                <ExamResult />
                            }
                            <button className="hibBtn main large full" onClick={reTest}>請重新作答</button>
                        </>
                        :
                        isComplete ?
                            <div className='complete-box'>
                                {
                                    ec.examInfo.ExamType == "1" &&
                                    <p className='complete-title'>
                                        全數做完題目！<br />
                                        恭喜你！作答完成！
                                    </p>
                                }
                                {
                                    ec.examInfo.ExamType == "3" &&
                                    <p className='complete-title'>
                                        作答完成！
                                    </p>
                                }
                                {
                                    /*
                                    答題內容對錯 先暫時不顯示
                                    <p>
                                        {
                                            ec.record.map((item: ExamRightAnswer) =>
                                                <span>{item.rightAns == item.userAns ? "O" : "X"}</span>
                                        )
                                        }
                                    </p>
                                    */
                                }
                                {
                                    ec.examInfo.ExamType == "1" &&
                                    <ExamResult />
                                }

                                {
                                    isUploading ?
                                        <>
                                            <CloudComplete />
                                            <p>
                                                上傳完成！
                                            </p>
                                        </> :
                                        "上傳成績中請稍後..."
                                }

                                {
                                    ec.examInfo.ExamType != "3" &&
                                    <div className='btns-box'>
                                        <button className="hibBtn main large" onClick={() => {
                                            window.open(`./CourseNew.html?pid=list&bid=${bc.BID}&Class2=${bc.Class2}&ActID=${bc.ActID}`, "_self")
                                        }}>回上頁</button>
                                        <button className="hibBtn main large" onClick={reTest}>再次作答</button>
                                    </div>
                                }
                            </div>
                            :
                            <>
                                {
                                    num == ec.examData.length ?
                                        <>
                                            <div className='finishMesg'>
                                                <div>
                                                    <Search color="rgb(12, 156, 12)" />
                                                </div>
                                                <div>
                                                    您已經完成所有題目了，您可以再次檢查修正您的答案，確認完成後即可按
                                                    <button className='hibBtn main' onClick={() => {
                                                        setOpen(true)
                                                    }}>交卷</button>
                                                    送出您的試卷。
                                                </div>
                                            </div>
                                            <HibModal
                                                showCross={false}
                                                className='large'
                                                show={open}
                                                cancel={() => {
                                                    setOpen(false)
                                                }}
                                                confirm={() => {
                                                    handInPaper()  
                                                }}
                                                children={<>確定是否要送出試卷</>}
                                            />
                                        </>
                                        :
                                        <>
                                            <ExamBasic
                                                nowNum={num}
                                                doAnswer={doAnswer}
                                                answerResult={props.answerResult}
                                            />
                                        </>
                                }
                                {
                                    ec.examInfo.AnsKind == "2" &&
                                    <ExamCheck />
                                }
                            </>

                }
            </>
        )
    } else {
        return (<div>設定中...</div>)
    }
}

export default ExamBody